import { motion, useAnimation } from "framer-motion";
import React, { useEffect } from "react";

import * as styles from "./styles.module.css";

const AnimatedCopy = ({ copy }) => {
  const copySplit = copy.split("/");

  const staggerVariant = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.25,
      },
    },
  };

  const itemVariant = {
    hidden: { opacity: 1, width: "0%" },
    show: { opacity: 1, width: "100%", transition: { duration: 0.7 } },
  };

  const controls = useAnimation();
  useEffect(() => {
    controls.start("show");
    setTimeout(() => {
      controls.start("hidden");
    }, 4000);
  }, [controls]);

  return (
    <motion.div
      variants={staggerVariant}
      initial="hidden"
      animate={controls}
      className={styles.container}
    >
      {copySplit.map((line, index) => (
        <motion.div variants={itemVariant} className={styles.item}>
          <span className={styles.itemSpan} key={index}>
            {line}
          </span>
        </motion.div>
      ))}
    </motion.div>
  );
};

export default AnimatedCopy;
